/* The login doors, from Login.dc.html. Each door sets its colours and fonts as variables, all from
   the tokens file; the layout below is shared. */
.door--library {
  --d-left: var(--shell-ink-03); --d-right: var(--shell-bg); --d-ink: var(--shell-ink); --d-soft: var(--shell-ink-62);
  --d-line: var(--shell-ink-18); --d-field: var(--shell-bg); --d-field-ink: var(--shell-ink);
  --d-btn: var(--shell-ink); --d-btn-ink: var(--shell-on-ink); --d-link: var(--shell-ink);
  --d-head: 'Manrope', sans-serif; --d-body: 'Manrope', sans-serif; --d-track: -0.01em; --d-weight: 700;
}
.door--cashflow {
  --d-left: var(--acc-green); --d-right: var(--acc-green); --d-ink: var(--on-dark); --d-soft: var(--on-dark-80);
  --d-line: var(--on-dark-40); --d-field: var(--on-dark); --d-field-ink: var(--acc-ink);
  --d-btn: var(--on-dark); --d-btn-ink: var(--acc-green); --d-link: var(--on-dark);
  --d-head: 'Inter Tight', sans-serif; --d-body: 'Inter', sans-serif; --d-track: 0; --d-weight: 700;
}
.door--poyt, .door--masterclass {
  --d-left: var(--poyt-navy); --d-right: var(--poyt-paper); --d-ink: var(--poyt-ink); --d-soft: var(--poyt-soft);
  --d-line: var(--poyt-line); --d-field: var(--on-dark); --d-field-ink: var(--poyt-ink);
  --d-btn: var(--poyt-orange); --d-btn-ink: var(--on-dark); --d-link: var(--poyt-navy);
  --d-head: 'Archivo', sans-serif; --d-body: 'IBM Plex Sans', sans-serif; --d-track: 0; --d-weight: 700;
}
.door--fe {
  --d-left: var(--fe-bg); --d-right: var(--fe-surface); --d-ink: var(--fe-text); --d-soft: var(--fe-muted);
  --d-line: var(--on-dark-18); --d-field: var(--on-dark-05); --d-field-ink: var(--fe-text);
  --d-btn: var(--fe-green); --d-btn-ink: var(--fe-on-green); --d-link: var(--fe-green);
  --d-head: 'Anton', sans-serif; --d-body: 'Archivo', sans-serif; --d-track: 0.01em; --d-weight: 400;
}
.door--acc {
  --d-left: var(--acc-bg); --d-right: var(--shell-bg); --d-ink: var(--acc-ink); --d-soft: var(--acc-soft);
  --d-line: var(--acc-rule); --d-field: var(--shell-bg); --d-field-ink: var(--acc-ink);
  --d-btn: var(--acc-green); --d-btn-ink: var(--on-dark); --d-link: var(--acc-green);
  --d-head: 'Inter Tight', sans-serif; --d-body: 'Inter', sans-serif; --d-track: 0; --d-weight: 700;
}

.door {
  --focus: var(--d-ink);
  display: flex; min-height: 100vh; background: var(--shell-bg); font-family: var(--shell-font);
}
.door-left { width: 50%; min-height: 100vh; position: relative; overflow: hidden; background: var(--d-left); }
.door-right {
  width: 50%; min-height: 100vh; position: relative;
  display: flex; flex-direction: column; justify-content: center;
  padding: 120px clamp(32px, 7.64vw, 110px);
  background: var(--d-right); color: var(--d-ink); font-family: var(--d-body);
}

/* Left halves */
.door-photo { width: 100%; height: 100%; min-height: 100vh; object-fit: cover; position: absolute; inset: 0; }
.door-art { position: absolute; inset: 0; padding: 72px; display: flex; flex-direction: column; }
.door-art--centre { justify-content: center; gap: 26px; }
.door-art--fe { gap: 28px; }
.door-art--spread { justify-content: space-between; color: var(--shell-ink); }

.mark--door { display: flex; align-items: center; gap: 10px; }
.mark--door .mark-name { font-weight: 800; font-size: 20px; }
.mark--door .mark-sub { font-weight: 500; font-size: 16px; color: var(--shell-ink-60); }
.mark-dot { width: 5px; height: 5px; border-radius: 3px; background: var(--shell-gold); flex-shrink: 0; }
.door-lib-middle { display: flex; flex-direction: column; gap: 22px; }
.door-lib-rule { width: 64px; height: 3px; background: var(--shell-gold); }
.door-lib-head { font-size: 52px; font-weight: 800; line-height: 1.08; letter-spacing: -0.01em; max-width: 520px; }
.door-swatches { display: flex; gap: 10px; margin-top: 10px; }
.swatch { width: 64px; height: 44px; border-radius: 8px; }
.swatch--fe { background: var(--fe-bg); box-shadow: inset 0 -4px 0 var(--fe-green); }
.swatch--acc { background: var(--acc-bg); border: 1px solid var(--acc-rule); box-shadow: inset 0 -4px 0 var(--acc-green); }
.swatch--poyt { background: var(--poyt-navy); box-shadow: inset 0 -4px 0 var(--poyt-orange); }
.swatch--pcfl { background: var(--acc-green); box-shadow: inset 0 -4px 0 var(--pcfl-accent); }
.swatch--masterclass { background: var(--poyt-orange); }
.door-lib-company { font-size: 14px; color: var(--shell-ink-60); }

.door-eyebrow {
  font-family: 'IBM Plex Sans', sans-serif; font-size: 14px; font-weight: 600;
  letter-spacing: 0.18em; text-transform: uppercase; color: var(--poyt-soft-on-navy);
}
.door-poyt-name { font-family: 'Archivo', sans-serif; font-size: 64px; font-weight: 800; line-height: 1.04; color: var(--on-dark); }
.door-masterclass-name { font-size: 56px; max-width: 560px; }
.poyt-underline { position: relative; display: inline-block; }
.poyt-underline > span {
  position: absolute; left: -4px; right: -8px; bottom: -8px; height: 7px;
  background: var(--poyt-orange); transform: skewX(-12deg);
}
.door-tagline { font-family: 'IBM Plex Sans', sans-serif; font-size: 20px; color: var(--poyt-soft-on-navy); }

.door-fe-bar { width: 72px; height: 6px; background: var(--fe-green); }
.door-fe-name { font-family: 'Anton', sans-serif; font-size: 104px; line-height: 0.98; color: var(--fe-text); }

.door-acc-name { font-family: 'Inter Tight', sans-serif; font-weight: 700; font-size: 20px; color: var(--acc-green); }
.door-acc-foot { display: flex; flex-direction: column; gap: 18px; }
.door-acc-rule { height: 1px; background: var(--acc-rule); }
.door-acc-line { font-family: 'Inter', sans-serif; font-size: 18px; color: var(--acc-soft); line-height: 1.6; max-width: 460px; }

/* Right halves */
.door-brand {
  position: absolute; top: 72px; left: clamp(32px, 7.64vw, 110px); right: clamp(32px, 7.64vw, 110px);
  display: flex; align-items: center; gap: 14px;
}
.door-brand .pentagon { flex-shrink: 0; }
.door-brand-text { display: flex; flex-direction: column; gap: 4px; }
.door-brand-name { font-family: 'Inter Tight', sans-serif; font-weight: 700; font-size: 20px; color: var(--on-dark); }
.door-brand-line { font-size: 14px; color: var(--on-dark-78); }

.door-form { display: flex; flex-direction: column; gap: 22px; }
.door-title {
  margin: 0; font-family: var(--d-head); font-size: 36px; font-weight: var(--d-weight);
  line-height: 1.15; letter-spacing: var(--d-track);
}
.door-lede { margin: 0; font-size: 17px; line-height: 1.55; color: var(--d-soft); }
.door-field { display: flex; flex-direction: column; gap: 8px; }
.door-field label { font-size: 14px; font-weight: 600; }
.door-field input {
  height: 52px; padding: 0 16px; border-radius: 10px; border: 1px solid var(--d-line);
  background: var(--d-field); color: var(--d-field-ink); font-size: 17px; width: 100%;
}
.door-field input.door-code { height: 60px; padding: 0 18px; font-size: 28px; letter-spacing: 0.4em; font-weight: 700; }
.door-btn {
  height: 54px; border-radius: 10px; border: none; background: var(--d-btn); color: var(--d-btn-ink);
  font-weight: 700; font-size: 17px; display: flex; align-items: center; justify-content: center;
}
.door-btn:disabled { opacity: 0.75; }
.door-links { display: flex; justify-content: space-between; gap: 16px; font-size: 15px; }
.door-link {
  background: none; border: none; padding: 0; color: var(--d-link); font-weight: 600;
  text-decoration: underline; text-align: left;
}
.door-help {
  padding: 16px 18px; border-radius: 10px; border: 1px solid var(--d-line);
  font-size: 15px; line-height: 1.55; color: var(--d-soft);
}
/* the code step's line for a code that hasn't come (member review, 11 Oct), with the help address to write to */
.door-note { margin: 0; font-size: 15px; line-height: 1.55; color: var(--d-soft); }
.door-note a { color: var(--d-link); font-weight: 600; overflow-wrap: anywhere; }
.door-error { margin: 0; font-size: 15px; line-height: 1.5; font-weight: 600; color: var(--d-ink); }
.door-legal {
  position: absolute; left: clamp(32px, 7.64vw, 110px); right: clamp(32px, 7.64vw, 110px); bottom: 56px;
  display: flex; gap: 22px; font-size: 14px; color: var(--d-soft);
}
.door-legal a { color: var(--d-soft); }
.door-legal a:hover { text-decoration: underline; }

/* A phone: the door's own look as a band across the top, then the form */
@media (max-width: 760px) {
  .door { flex-direction: column; background: var(--d-right); }
  .door-left, .door-right { width: 100%; min-height: 0; }
  .door-left { min-height: 0; }
  .door-art { position: static; padding: 32px 16px; gap: 18px; }
  .door-art--spread { gap: 22px; }
  .door-photo { position: static; min-height: 0; height: 200px; }
  .door-lib-head { font-size: 30px; }
  .door-swatches { gap: 8px; margin-top: 4px; }
  .swatch { width: 44px; height: 30px; border-radius: 6px; }
  .door-lib-company { display: none; }
  .door-eyebrow { font-size: 12px; }
  .door-poyt-name { font-size: 40px; }
  .door-masterclass-name { font-size: 32px; }
  .door-tagline { font-size: 17px; }
  .door-fe-bar { width: 48px; height: 5px; }
  .door-fe-name { font-size: 56px; }
  .door-acc-line { font-size: 16px; }
  /* the right half fills whatever the form leaves of the screen, so no white band shows under it */
  .door-right { flex: 1 0 auto; padding: 28px 16px 36px; justify-content: flex-start; }
  .door-brand { position: static; margin-bottom: 28px; }
  .door-title { font-size: 30px; }
  .door-links { flex-direction: column; gap: 14px; }
  .door-legal { position: static; margin-top: 40px; }
}
